import {
    GET_ALL_404_URLS,
    ALL_404_URLS_ERROR,
    GET_ALL_301_REDIRECTS,
    GET_301_REDIRECTS_PAGINATED,
    GET_301_REDIRECTS_PAGINATED_ERROR,
    GET_301_REDIRECTS_COUNT,
    GET_301_REDIRECTS_COUNT_ERROR,
    ALL_301_REDIRECTS_ERROR,
    ADD_301_REDIRECTS_BULK,
    ADD_301_REDIRECTS_BULK_ERROR,
    ADD_301_REDIRECT,
    ADD_301_REDIRECT_ERROR,
    GET_404_REDIRECTS_COUNT,
    GET_404_REDIRECTS_COUNT_ERROR,
    GET_404_REDIRECTS_PAGINATED,
    GET_404_REDIRECTS_PAGINATED_ERROR,
} from "../actions/types";

const initialState = {
    Page404urls: [],
    Page301redirects: [],
    paginated301Redirects: [],
    paginated404Redirects: [],
    count: null,
    count404: null,
    isLoading: true,
    isLoading301: true,
    isLoading404: true,
    success: false,
};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {
        case GET_ALL_404_URLS:
            return {
                ...state,
                Page404urls: payload,
                isLoading: false,
                success: true,
            };
        case GET_ALL_301_REDIRECTS:
            return {
                ...state,
                Page301redirects: payload,
                isLoading: false,
                success: true,
            };
        case GET_301_REDIRECTS_PAGINATED:
            return {
                ...state,
                paginated301Redirects: payload,
                isLoading301: false,
                success: true,
            };
        case GET_301_REDIRECTS_COUNT:
            return {
                ...state,
                count: payload,
                isLoading: false,
                success: true,
            };
        case GET_404_REDIRECTS_COUNT:
            return {
                ...state,
                count404: payload,
                isLoading: false,
                success: true,
            };
        case GET_404_REDIRECTS_PAGINATED:
            return {
                ...state,
                paginated404Redirects: payload,
                isLoading404: false,
                success: true,
            };
        case ADD_301_REDIRECTS_BULK:
        case ADD_301_REDIRECT:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case ADD_301_REDIRECTS_BULK_ERROR:
        case ADD_301_REDIRECT_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
            };
        case ALL_404_URLS_ERROR:
            return {
                ...state,
                Page404urls: payload,
                isLoading: false,
                success: false,
            };
        case ALL_301_REDIRECTS_ERROR:
            return {
                ...state,
                Page301redirects: payload,
                isLoading: false,
                success: false,
            };
        case GET_301_REDIRECTS_PAGINATED_ERROR:
            return {
                ...state,
                paginated301Redirects: [],
                isLoading301: false,
                success: false,
            };
        case GET_301_REDIRECTS_COUNT_ERROR:
            return {
                ...state,
                count: null,
                isLoading: false,
                success: false,
            };
        case GET_404_REDIRECTS_COUNT_ERROR:
            return {
                ...state,
                count404: null,
                isLoading: false,
                success: false,
            };
        case GET_404_REDIRECTS_PAGINATED_ERROR:
            return {
                ...state,
                paginated404Redirects: [],
                isLoading404: false,
                success: false,
            };
        default:
            return state;
    }
}
